export const CDN_CONECKTA = "https://cdn.conekta.io/js/latest/conekta.js";
